import axios from './axiosService';
import fetchService from './fetchService';

/**
 * MLD-7490
 */
export default {
  async getConversations(params = {}, batchSize = 1_000, concurrentRequests = 1) {
    return await fetchService.fetchRecords(`/api/sinch/conversations`, params, batchSize, concurrentRequests);
  },
  async getConversationsForCurrentUser(params = {}, batchSize = 100, concurrentRequests = 1) {
    return await fetchService.fetchRecords(`/api/user/sinch/conversations`, params, batchSize, concurrentRequests);
  },
  async getConversation(conversationID) {
    const {data} = await axios.get(`/api/sinch/conversations/${conversationID}`)
    return data;
  },
  async createConversation(form) {
    const response = await axios.post('/api/sinch/conversations', form);
    return response.data;
  },
  async markAsRead(conversationID) {
    const response = await axios.patch(`/api/sinch/conversations/${conversationID}/mark-as-read`);
    return response.data;
  },
  async getConversationMessages(conversationID) {
    const {data} = await axios.get(`/api/sinch/conversations/${conversationID}/messages`)
    return data;
  },
  async sendMessage(conversationID, content) {

  },
  async getAssignedNumbers() {
    const {data: numbers} = await axios.get('/api/sinch/assigned-numbers');
    return numbers;
  },
  getCountries() {
    return [
      {
        id: 'US', name: 'United States',
      }
    ]
  },
  populateForm(configuration) {
    return {
      code: configuration.code,
      company_name: configuration.company_name,
      allowed_countries: configuration.allowed_countries,
      source_number: configuration.source_number,
      message_prefix: configuration.message_prefix,
      sinch_account_id: configuration.sinch_account_id,
      privacy_policy_url: configuration.privacy_policy_url,
      privacy_policy_content: configuration.privacy_policy_content,
      terms_url: configuration.terms_url,
      terms_content: configuration.terms_content,
    }
  },
  async getConfigurations() {
    const {data: configurations} = await axios.get('/api/sinch/configurations');
    return configurations;
  },
  async getConfiguration(configurationID) {
    const {data: configuration} = await axios.get(`/api/sinch/configurations/${configurationID}`);
    return configuration;
  },
  async getContacts(params = {}, batchSize = 1_000, concurrentRequests = 4) {
    return await fetchService.fetchRecords(`/api/sinch/contacts`, params, batchSize, concurrentRequests);
  },
  async getTemplates(params = {}, batchSize = 1_000, concurrentRequests = 4) {
    return await fetchService.fetchRecords(`/api/sinch/templates`, params, batchSize, concurrentRequests);
  },
  async getTemplatesForUser(params = {}, batchSize = 1_000, concurrentRequests = 4) {
    return await fetchService.fetchRecords(`/api/user/sinch/templates`, params, batchSize, concurrentRequests);
  },
  async getTemplate(templateID) {
    const {data} = await axios.get(`/api/sinch/templates/${templateID}`);
    return data;
  },
  async renderTemplate(templateID, sinchContactID, presentationID) {
    const form = {
      sinch_contact_id: sinchContactID,
      presentation_id: presentationID,
    }
    const {data} = await axios.post(`/api/sinch/templates/${templateID}/render`, form);
    return data.content;
  }
}
